import { useEffect, useState } from "react";
import { Button, Label, Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { Edit, Trash } from "react-feather";

import { SelectSearch } from "components/SelectSearch";
import { brandsSuggestion, getOneMarkup } from "services/api";
import { Cut } from "components/Cut";
import { TableButton } from "components/TableButton";
import { toast } from "react-toastify";

import { CloseButton } from "components/CloseButton";
import { MySpinner } from "components/MySpinner";

import { MarkupModal } from "../MarkupModal";

import { markupRender } from "./MarkupRender";
import "./markupBrand.scss";

export const MarkupBrand = ({ setMarkupBrand, markupBrand }) => {
  const [brand, setBrand] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [markup, setMarkup] = useState(null);
  const [addBrandShown, setAddBrandShown] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const addMarkupBrandHandler = () => {
    if (markupBrand.find(v => v.id === brand.value && v.markup === markup.id)) {
      toast.error("Такое правило уже существует");
      return;
    }
    setMarkupBrand(prev => ([
      ...prev,
      {
        id: brand.value,
        name: brand.label,
        markup
      }
    ]));
    setBrand(null);
    setMarkup(null);
    setAddBrandShown(false);
  }

  useEffect(() => {
    if (addBrandShown === false) {
      setIsEdit(false);
    }
  }, [addBrandShown]);

  const updateMarkupBrandHandler = () => {
    setMarkupBrand(prev => {

      const newMarkupBrand = [...prev];
      const index = newMarkupBrand.findIndex(v => v.id === brand.value);

      newMarkupBrand[index] = {
        id: brand.value,
        name: brand.label,
        markup
      };
      return newMarkupBrand;
    });

    setBrand(null);
    setMarkup(null);
    setAddBrandShown(false);
  };

  const openModalAdd = () => {
    setBrand(null);
    setMarkup(null);
    setAddBrandShown(true);
  }

  const markupHandler = (markup) => {
    setMarkup(markup);
    setOpenModal(false);
  };

  const openModalEdit = (id) => {
    setAddBrandShown(true);
    const newMarkupBrand = markupBrand.filter(v => v.id === id)[0];
    setIsEdit(true);
    setMarkup(newMarkupBrand.markup);
    setBrand({ label: newMarkupBrand.name, value: newMarkupBrand.id });

  }

  const removeMarkupHandler = (id) => {
    setMarkupBrand(prev => {
      const newMarkupBrand = [...prev];
      return newMarkupBrand.filter(v => v.id !== id);
    });
  }

  return <div className="markupBrand mt-3">
    <Label>Наценка на бренд</Label>
    <div className="react-bootstrap-table p-0">
      <Table className="table table-hover">
        <thead>
          <tr>
            <th style={{ width: "50%" }}>Бренд</th>
            <th style={{ width: "40%" }}>Наим.наценки</th>
            <th style={{ width: "8%" }}></th>
            <th style={{ width: "8%" }}></th>
          </tr>
        </thead>
        <tbody>
          {markupBrand.map(item =>
            <tr key={`${item.id}${item.markup}`}>
              <td><Cut>{item.name}</Cut></td>
              <td>
                <Cut>{item.markup?.name}</Cut>
              </td>
              <td>
                <TableButton
                  Icon={Edit}
                  onClick={() => openModalEdit(item.id)}
                />
              </td>
              <td>
                <TableButton
                  Icon={Trash}
                  onClick={() => removeMarkupHandler(item.id)}
                />
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>

    <Modal
      isOpen={addBrandShown}
      toggle={() => setAddBrandShown(false)}
      className="markup-modal"
    >
      {loading && <MySpinner overlay />}
      <ModalHeader>
        <div className="modal-title-text">
          {isEdit ?
            `Редактирование наценки на бренд ${brand?.label}`
            : 'Новое правило наценки на бренд'
          }
        </div>
        <CloseButton onClick={() => setAddBrandShown(false)} />
      </ModalHeader>
      <ModalBody className=" m-3">
        <div>
          <Label>Бренд</Label>
          <SelectSearch
            name="brand"
            placeholder="Выберите бренд"
            functionSuggestion={brandsSuggestion}
            value={brand}
            setValue={setBrand}
            isClearable
            isDisabled={isEdit}
          />
        </div>
        <div className="mt-2">
          <Label>Наценка</Label>
          {markup ?
            <div className="selectedMarkup">
              <b>{markup.name}:</b> {markupRender(markup.markup)}
            </div>
            : <div className="selectedMarkup">Не выбрана наценка</div>}
          <Button onClick={() => setOpenModal(true)} color="primary" className="mt-2">
            Выбрать наценку
          </Button>
          <div className="d-flex justify-content-end">
            <Button onClick={() => { isEdit ? updateMarkupBrandHandler() : addMarkupBrandHandler() }} color="primary" className="mt-2" disabled={!brand || !markup}>
              Применить наценку на бренд
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>

    <Button onClick={() => openModalAdd()} color="primary" className="mt-2">
      Добавить наценку на бренд
    </Button>

    <MarkupModal
      openModal={openModal}
      setOpenModal={setOpenModal}
      onClick={markupHandler}
    />
  </div>
}